/**
 * description 租户间稿件共享弹框
 * created by zhang.yingyu
 * created on 2019-05-17
 */
'use strict';
angular.module('tenantShareManuModule', []).controller('tenantShareManuCtrl', [
    '$scope',
    '$modalInstance',
    '$validation',
    'modalDialog',
    'trsHttpService',
    'incomeParams',
    'trsspliceString',
    function($scope, $modalInstance, $validation, modalDialog, trsHttpService, incomeParams, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                items: [],
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            queryGroupTenantsForMe();
        }

        /**
         * [queryGroupTenantsForMe 查询合作租户]
         * @return {[type]} [description]
         */
        function queryGroupTenantsForMe() {
            var params = {
                serviceid: 'mlf_cooperationgroup',
                methodname: 'queryGroupTenantsForMe',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.items = data;
            });
        }

        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            if ($scope.data.selectedArray.length > 0) {
                var params = angular.copy(incomeParams);
                params.targetTenantIds = trsspliceString.spliceString($scope.data.selectedArray, 'TENANTID', ',');
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType('稿件共享成功', '', 'success', false, function() {
                            $modalInstance.close('success');
                        });
                    }
                });
            } else {
                modalDialog.saveModel('共享失败', '请选择要共享的租户', 'error');
            }
        };
    },
]);
